import { render, staticRenderFns } from "./DeleteCrateProtocolDialog.vue?vue&type=template&id=383c357b&"
import script from "./DeleteCrateProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteCrateProtocolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports